import { render, staticRenderFns } from "./AppAvatar.vue?vue&type=template&id=9a84c39a&scoped=true&"
import script from "./AppAvatar.vue?vue&type=script&lang=js&"
export * from "./AppAvatar.vue?vue&type=script&lang=js&"
import style0 from "./AppAvatar.vue?vue&type=style&index=0&id=9a84c39a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a84c39a",
  null
  
)

export default component.exports